(function () {

    "use strict";

    var shiftTemplateUtils;
    var brandBusinessDayUtils;

    var AvailabilityDataService = function () {

        var self = this;

        self.flatData = {'intervals': []};
        const DAY = 24 * 60 * 60 * 1000;

        self.parseData = function (availabilityData) {
            var dayOpen = shiftTemplateUtils.secondsToTimeObj(self.dayOpenHour / 1000);

            for (var i in availabilityData['intervals']) {
                var interval = angular.copy(availabilityData['intervals'][i]);
                var dayOpenTime = moment(interval.start_time).hours(dayOpen.hours).minutes(dayOpen.minutes).valueOf();
                interval.start_time = moment(interval.start_time).valueOf();
                interval.end_time = moment(interval.end_time).valueOf();

                if (interval.start_time < dayOpenTime) {
                    interval.start_time += DAY;
                }

                if (interval.end_time <= interval.start_time) {
                    interval.end_time += DAY;
                }

                var rowTimeZone = new Date(dayOpenTime).getTimezoneOffset();
                var startTimeZone = new Date(interval['start_time']).getTimezoneOffset();
                var endTimeZone = new Date(interval['end_time']).getTimezoneOffset();

                interval.start_time += (startTimeZone - rowTimeZone) * 60 * 1000;
                interval.end_time += (endTimeZone - rowTimeZone) * 60 * 1000;

                self.flatData['intervals'].push(interval);
            }

            sortAvailabilitySlots();
        };

        var sortAvailabilitySlots = function() {
            self.flatData['intervals'].sort(function (slot1, slot2) {
                if (slot1.state === slot2.state) {
                    return 0;
                }
                else if (slot1.state === "PREFERRED_TIME") {
                    return 1;
                }
                else if (slot2.state === "PREFERRED_TIME") {
                    return -1;
                }

                return 0;
            });
        };

        self.setBusinessDay = function (selectedDay, businessDays) {
            var selectedDayTime = new Date(selectedDay).getTime();
            self.businessDays = businessDays || self.businessDays;

            for (var i in self.businessDays) {
                var businessDayTime = moment(self.businessDays[i].start_date, "YYYY-MM-DD").valueOf();

                if (selectedDayTime >= businessDayTime) {
                    self.businessDay = self.businessDays[i];
                    break;
                }
            }

            self.dayOpenHour = self.businessDay? self.businessDay.open_time * 1000: 0;
            self.dayCloseHour = self.businessDay? self.businessDay.close_time * 1000: 0;

            if (self.dayCloseHour <= self.dayOpenHour) {
                self.dayCloseHour += DAY;
            }
        };

        self.setScheduleBrandId = function (brandId) {
            self.brandId = brandId;
        };

        var doOverlap = function (interval1, interval2) {
            var interval1Start = new Date(interval1.start_time).getTime();
            var interval2Start = new Date(interval2.start_time).getTime();
            var interval1End = new Date(interval1.end_time).getTime();
            var interval2End = new Date(interval2.end_time).getTime();

            if (
                (interval1Start < interval2Start && interval1End < interval2Start) ||
                (interval1End > interval2End && interval1Start > interval2End)
            ) {
                return false;
            }

            return true;
        };

        self.mergeOverlaps = function () {
            for (var i = self.flatData['intervals'].length - 1; i >= 0; i--) {
                var interval1 = self.flatData['intervals'][i];

                for (var j = i + 1; j < self.flatData['intervals'].length; j++) {
                    var interval2 = self.flatData['intervals'][j];

                    if (interval1.state === interval2.state && doOverlap(interval1, interval2) && interval1.day === interval2.day) {
                        self.flatData['intervals'][j].start_time = interval1.start_time < interval2.start_time? interval1.start_time: interval2.start_time;
                        self.flatData['intervals'][j].end_time = interval1.end_time > interval2.end_time? interval1.end_time: interval2.end_time;
                        self.flatData['intervals'].splice(i, 1);
                        break;
                    }
                }
            }
        };

        self.addInterval = function (interval, dontMerge) {
            interval.start_time = moment(interval.start_time).valueOf();
            interval.end_time = moment(interval.end_time).valueOf();

            if (interval.end_time <= interval.start_time) {
                interval.end_time += DAY;
            }

            self.flatData['intervals'].push(interval);

            if (!dontMerge) {
                self.mergeOverlaps();
            }
        };

        self.isWithinIntervalTime = function(intervals, slot) {
            var shiftIntervals = brandBusinessDayUtils.normalizeTimeIntervals(intervals, self.dayOpenHour);
            return shiftTemplateUtils.isWithinShiftTime(shiftIntervals, slot);
        };

        self.checkSlotAllowedArea = function (intervals, slot, availabilityRequestType) {
            var shiftIntervals = brandBusinessDayUtils.normalizeTimeIntervals(intervals, self.dayOpenHour);

            if (availabilityRequestType === TSAvailabilityAPI.AVAILABILITY_STATES.AVAILABLE) {
                return shiftTemplateUtils.isWithinShiftTime(shiftIntervals, slot);
            } else {
                var isOverlapping = false;

                for (var i in intervals) {
                    var interval = intervals[i];

                    if (doOverlap(interval, slot)) {
                        isOverlapping = true;
                        break;
                    }
                }

                return !isOverlapping;
            }
        };

        self.deleteInterval = function (interval) {
            for (var i in self.flatData['intervals']) {
                var existingInterval = self.flatData['intervals'][i];

                if (
                    existingInterval.state === interval.state &&
                    existingInterval.start_time == interval.start_time &&
                    existingInterval.end_time == interval.end_time
                ) {
                    self.flatData['intervals'].splice(i, 1);
                    break;
                }
            }
        };

        self.deletePreferredTimeIntervals = function () {
            self.flatData['intervals'] = _.filter(self.flatData['intervals'], function (interval) {
                return interval.state !== TSAvailabilityAPI.AVAILABILITY_STATES.PREFERRED_TIME
            });
        };

        var prepareWeekDays = function (brand) {
            var weekDays = [];
            const startOfWeek = getWeekStart(moment('1971-01-01'), brand.startDayOfWeek);

            for (var i = 0; i < 7; i++) {
                var weekDay = startOfWeek.clone().add(i, 'days');
                var day = weekDay.format('ddd').toUpperCase();
                var date = weekDay.format('YYYY-MM-DD');
                weekDays.push({day: day, intervals: [], date: date})
            }

            for (var i in self.flatData['intervals']) {
                var interval = self.flatData['intervals'][i];
                var weekDay = weekDays.find(function (weekDay) {
                    return weekDay.day === interval.day;
                });
                weekDay['intervals'].push(interval);
            }

            return weekDays;
        };

        self.switchAvailabilityState = function (brand) {
            var weekDays = prepareWeekDays(brand);
            var intervals = [];
            self.reset();

            for (var day in weekDays) {
                var weekDay = weekDays[day];
                if (weekDay.intervals && weekDay.intervals.length > 0) {
                    var preferredIntervals = _.filter(weekDay.intervals,function (interval){
                        return interval.state === 'PREFERRED_TIME';
                    });
                    var dayDetails = addRemainingDayAvailabilities(weekDay, true);
                    intervals = intervals.concat(dayDetails.intervals, preferredIntervals);
                }
            }

            self.flatData = {'intervals': intervals};
        };

        const isIntervalAllDay = (dayIntervals) => {
            const availabilityIntervals = dayIntervals.filter((interval) => {
                return interval.state !== TSAvailabilityAPI.AVAILABILITY_STATES.PREFERRED_TIME;
            });

            return availabilityIntervals.length === 1;
        };

        self.prepareWeekAvailability = function (brand) {
            var weekDays = prepareWeekDays(brand);
            var intervals = [];

            for (var i in weekDays) {
                var dayDetails = addRemainingDayAvailabilities(weekDays[i], false);
                const isAllDay = isIntervalAllDay(dayDetails['intervals']);

                for (var j in dayDetails['intervals']) {
                    var interval = dayDetails['intervals'][j];
                    var intervalStart = moment(interval.start_time);
                    var intervalEnd = moment(interval.end_time);

                    var formattedInterval = {
                        day: interval.day,
                        from_time: intervalStart.format("HH:mm"),
                        to_time: intervalEnd.format("HH:mm"),
                        is_all_day: isAllDay,
                        state: interval.state
                    };

                    intervals.push(formattedInterval);
                }
            }

            return intervals;
        };

        var addRemainingDayAvailabilities = function (dayDetails, isSwitchState) {
            var newIntervals = [];
            var state;

            dayDetails.intervals = dayDetails.intervals.sort(function (interval1, interval2) {
                return interval1.start_time > interval2.start_time ? 1 : -1;
            });

            if (isSwitchState) {
                state = self.state
            } else {
                state = self.state === TSAvailabilityAPI.AVAILABILITY_STATES.AVAILABLE ? TSAvailabilityAPI.AVAILABILITY_STATES.UNAVAILABLE : TSAvailabilityAPI.AVAILABILITY_STATES.AVAILABLE;
            }

            var dayOpenTime = shiftTemplateUtils.secondsToTimeObj(self.dayOpenHour / 1000);
            var dayCloseTime = shiftTemplateUtils.secondsToTimeObj(self.dayCloseHour / 1000);

            var dayOpen = moment(dayDetails.date).hours(dayOpenTime.hours).minutes(dayOpenTime.minutes).valueOf();
            var dayClose = moment(dayDetails.date).hours(dayCloseTime.hours).minutes(dayCloseTime.minutes).valueOf();

            var dayIntervals = _.filter(dayDetails.intervals, function (interval) {
                return interval.state !== TSAvailabilityAPI.AVAILABILITY_STATES.PREFERRED_TIME;
            });

            for (var i = 0; i <= dayIntervals.length; i++) {
                if (dayIntervals.length) {
                    if (i == 0) {
                        var startTime = normalizeInterval(dayIntervals[i]).start_time
                        if (startTime === self.dayOpenHour) {
                            continue;
                        }
                    }
                    if (i == dayIntervals.length) {
                        var endTime = normalizeInterval(dayIntervals[i - 1]).end_time
                        if (endTime === self.dayCloseHour) {
                            continue;
                        }
                    }
                }
                var newInterval = {
                    day: dayDetails.day,
                    is_all_day: !dayIntervals.length,
                    state: state
                }
                if (i == 0) {
                    newInterval.start_time = dayOpen;
                } else {
                    newInterval.start_time = dayIntervals[i - 1].end_time;
                }
                if (i == dayIntervals.length) {
                    newInterval.end_time = dayClose;
                } else {
                    newInterval.end_time = dayIntervals[i].start_time;
                }
                newIntervals.push(newInterval);
            }

            dayDetails.intervals = isSwitchState ? newIntervals : dayDetails.intervals.concat(newIntervals);
            return dayDetails;
        };

        var normalizeInterval = function (interval) {
            var startTime = ((moment(interval.start_time).hours() * 60 * 60) + (moment(interval.start_time).minutes() * 60)) * 1000;
            var endTime = ((moment(interval.end_time).hours() * 60 * 60) + (moment(interval.end_time).minutes() * 60)) * 1000;

            if (startTime < self.dayOpenHour) {
                startTime += DAY;
            }

            if (startTime >= endTime) {
                endTime += DAY;
            }
            return {
                start_time: startTime,
                end_time: endTime
            };
        };

        self.setPreferredTimeEnabled = function (preferredTimeEnabled) {
            self.preferredTimeEnabled = preferredTimeEnabled;
        };

        self.reset = function () {
            self.flatData = {'intervals': []};
        };
    };

    angular
        .module("harriApp")
        .service('availabilityDataService', ['ShiftTemplateUtils', 'businessDayUtils',
            function (ShiftTemplateUtils, businessDayUtils) {
                shiftTemplateUtils = ShiftTemplateUtils;
                brandBusinessDayUtils = businessDayUtils;
                return function () {
                    return new AvailabilityDataService();
                }
            }
        ]);
})();
